import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "pa-2" }

import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { computed } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'CardEmparejamientos',
  props: {
    partidas: {},
    numeroRonda: {},
    soloEquipos: {}
  },
  setup(__props: any) {

const props = __props;

const emparejamientosUnicos = computed(() => {
  const set = new Set<string>();
  const resultado: {
    equipo1: string;
    equipo2: string;
    idEquipo1: number | null;
    idEquipo2: number | null;
  }[] = [];

  props.partidas
    .filter((p) => p.numeroRonda === props.numeroRonda)
    .forEach((partida) => {
      const equipoA = partida.nombreEquipo1?.trim();
      const equipoB = partida.nombreEquipo2?.trim();
      const clave = [equipoA, equipoB].sort().join("|"); // Normaliza para detectar duplicados sin importar el orden

      if (!set.has(clave)) {
        set.add(clave);
        resultado.push({
          equipo1: equipoA as string,
          equipo2: equipoB as string,
          idEquipo1: partida.idEquipo1,
          idEquipo2: partida.idEquipo2,
        });
      }
    });

  return resultado;
});

const visibles = computed(() =>
  emparejamientosUnicos.value
    .map((mesa, index) => ({ ...mesa, numero: index + 1 }))
    .filter(
      mesa =>
        !props.soloEquipos ||
        (mesa.idEquipo1 != null && props.soloEquipos.includes(mesa.idEquipo1)) ||
        (mesa.idEquipo2 != null && props.soloEquipos.includes(mesa.idEquipo2))
    )
);

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_hover, null, {
      default: _withCtx(({ props: hoverProps }) => [
        _createVNode(_component_v_card, _mergeProps(hoverProps, {
          class: "match-card mt-3 mx-auto",
          width: "100%",
          "max-width": "600",
          elevation: "2"
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (mesa) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: mesa.numero,
                    class: "mb-2"
                  }, [
                    _createElementVNode("strong", null, "Mesa " + _toDisplayString(mesa.numero) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(mesa.equipo1) + " vs " + _toDisplayString(mesa.equipo2), 1)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    })
  ]))
}
}

})